import { createApp } from "vue";
import App from "./App.vue";
import router from "./screens/router";

import * as Sentry from "@sentry/vue";

const app = createApp(App);

if (process.env.VUE_APP_ENV === "production") {
  Sentry.init({
    app,
    dsn: "https://32400ffe63938fce634eba5b819b98d6@o826155.ingest.us.sentry.io/4508046371651584",
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.replayIntegration(),
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

app.use(router).mount("#app");
